import { cn } from "@/lib/utils";

export interface DiffLine {
  type: "hunk" | "add" | "del" | "ctx";
  text: string;
  oldNo?: number;
  newNo?: number;
}

/** Lê um diff unificado (formato `git diff`) em linhas com numeração antiga e nova. */
export function parsePatch(patch: string): DiffLine[] {
  const out: DiffLine[] = [];
  let oldNo = 0;
  let newNo = 0;
  for (const raw of patch.split("\n")) {
    if (raw.startsWith("--- ") || raw.startsWith("+++ ") || raw.startsWith("\\ ")) continue;
    const hunk = /^@@ -(\d+)(?:,\d+)? \+(\d+)(?:,\d+)? @@(.*)$/.exec(raw);
    if (hunk) {
      oldNo = Number(hunk[1]);
      newNo = Number(hunk[2]);
      out.push({ type: "hunk", text: raw });
    } else if (raw.startsWith("+")) out.push({ type: "add", text: raw.slice(1), newNo: newNo++ });
    else if (raw.startsWith("-")) out.push({ type: "del", text: raw.slice(1), oldNo: oldNo++ });
    else if (raw.startsWith(" "))
      out.push({ type: "ctx", text: raw.slice(1), oldNo: oldNo++, newNo: newNo++ });
  }
  return out;
}

/** Diff com duas colunas de números, verde para o que entrou e vermelho para o que saiu. */
export function DiffView({ patch, className }: { patch: string; className?: string }) {
  const lines = parsePatch(patch);
  return (
    <div
      className={cn(
        "overflow-auto rounded-lg border border-border bg-bg-subtle font-mono text-[12px] leading-[1.65]",
        className,
      )}
    >
      <table className="w-full border-collapse">
        <tbody>
          {lines.map((l, i) =>
            l.type === "hunk" ? (
              <tr key={i} className="bg-bg-muted text-fg-subtle">
                <td colSpan={3} className="px-3 py-0.5 text-[11px]">
                  {l.text}
                </td>
              </tr>
            ) : (
              <tr
                key={i}
                className={l.type === "add" ? "diff-add" : l.type === "del" ? "diff-del" : undefined}
              >
                <td className="w-10 select-none px-2 text-right text-[11px] text-fg-subtle opacity-70">
                  {l.oldNo ?? ""}
                </td>
                <td className="w-10 select-none px-2 text-right text-[11px] text-fg-subtle opacity-70">
                  {l.newNo ?? ""}
                </td>
                <td className="whitespace-pre pr-4">
                  <span className="mr-2 select-none opacity-60">
                    {l.type === "add" ? "+" : l.type === "del" ? "−" : " "}
                  </span>
                  {l.text}
                </td>
              </tr>
            ),
          )}
        </tbody>
      </table>
    </div>
  );
}
